(function($, Drupal) {
    'use strict';
    Drupal.behaviors.slideshowPage = {
        attach : function() {
            var sliderSlickOption = {
                dots : false,
                arrow : false,
                prevArrow : $('.slick-custom-prev'),
                nextArrow : $('.slick-custom-next')
            };

            var slider = $('.diaporama-page-carousel').not('.slick-initialized').slick(sliderSlickOption);
            var sliderContainer = $('.diaporama-page-carousel-container');
            var body = $('body');

            $('.on-click-open-diaporama-slider').click(function(){
                sliderContainer.removeClass('hidden');
                body.addClass('modal-open');
                slider.slick('slickGoTo', $(this).data('index'), true);
            });

            $('.carousel-close').click(function(){
                sliderContainer.addClass('hidden');
                body.removeClass('modal-open');
            });
        }
    };
})(jQuery, Drupal);
